import React from 'react';
import { Empty } from 'antd';

import { OverlayLoader } from 'components';

import { IListBlockProps } from './ListBlock.types';

import './ListBlock.styles.scss';

const ListBlock = ({
  header,
  height,
  maxHeight,
  maxWidth,
  loading,
  error,
  empty,
  children,
  style,
  className = '',
  ...props
}: IListBlockProps) => {
  const errorClass = error ? 'np-list-block--error' : '';

  return (
    <div className={`np-list-block ${errorClass} ${className}`} style={{ maxWidth, ...style }} {...props}>
      {header && <div className="np-list-block__header">{header}</div>}

      <div className="np-list-block__body" style={{ height, maxHeight }}>
        {loading && <OverlayLoader borderRadius={16} />}

        {empty && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}

        {!loading && !empty && children}
      </div>

      <div className="np-list-block__overlay" style={{ display: loading ? 'block' : 'none' }} />
    </div>
  );
};

export default ListBlock;
